import { EmbedShadowRoot } from '@infl-ts/ui-shadow-dom';
import { DisplayQueryError } from '@infl-ts/util-query-errors';
import { useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import { Drawer } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { pipe } from 'fp-ts/function';
import { useTranslation } from 'react-i18next';
import LoadingError from './loading-error';
import PlayerBody from './player-body';
import PlayerSkeleton from './player-skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
export var ChallengePlayerContent = function ChallengePlayerContent(_ref) {
  var _challengeConfig$onbo;

  var challengeData = _ref.challengeData,
      scrollToChallengeTop = _ref.scrollToChallengeTop;

  var _useChallengePlayer = useChallengePlayer(),
      closeChallengePlayer = _useChallengePlayer.closeChallengePlayer,
      challengeConfig = _useChallengePlayer.challengePlayerState.challengeConfig;

  var isOnboarding = (_challengeConfig$onbo = challengeConfig === null || challengeConfig === void 0 ? void 0 : challengeConfig.onboarding) !== null && _challengeConfig$onbo !== void 0 ? _challengeConfig$onbo : false;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return pipe(challengeData, DE.refreshFold(function () {
    return /*#__PURE__*/_jsx(PlayerSkeleton, {
      onClose: closeChallengePlayer,
      showHeaderActions: !isOnboarding
    });
  }, function () {
    return /*#__PURE__*/_jsx(PlayerSkeleton, {
      onClose: closeChallengePlayer,
      showHeaderActions: !isOnboarding
    });
  }, function (err, refreshing) {
    return /*#__PURE__*/_jsx(DisplayQueryError, {
      err: err,
      refreshing: refreshing,
      message: t('Could not load challenge at this time, try again.'),
      children: function children() {
        return /*#__PURE__*/_jsx(LoadingError, {});
      }
    });
  }, function (_ref2) {
    var _challengeConfig$canC;

    var challenge = _ref2.challenge,
        profile = _ref2.profile;
    return /*#__PURE__*/_jsx(PlayerBody, {
      challenge: challenge,
      profile: profile,
      isOnboarding: isOnboarding,
      canClose: (_challengeConfig$canC = challengeConfig === null || challengeConfig === void 0 ? void 0 : challengeConfig.canClose) !== null && _challengeConfig$canC !== void 0 ? _challengeConfig$canC : true,
      scrollToChallengeTop: scrollToChallengeTop
    });
  }));
};

var ChallengePlayerDrawer = function ChallengePlayerDrawer(_ref3) {
  var open = _ref3.open,
      challengeConfig = _ref3.challengeConfig,
      drawerPaperRef = _ref3.drawerPaperRef,
      children = _ref3.children;
  return /*#__PURE__*/_jsx(Drawer, {
    open: open,
    transitionDuration: challengeConfig !== null && challengeConfig !== void 0 && challengeConfig.onboarding ? 0 : undefined,
    anchor: "bottom",
    hideBackdrop: challengeConfig === null || challengeConfig === void 0 ? void 0 : challengeConfig.minimized,
    elevation: challengeConfig !== null && challengeConfig !== void 0 && challengeConfig.minimized ? 0 : 16,
    variant: challengeConfig !== null && challengeConfig !== void 0 && challengeConfig.minimized ? 'permanent' : 'temporary',
    disablePortal: true,
    PaperProps: {
      id: 'publicResponsesScroll',
      sx: {
        overflowX: 'hidden',
        height: challengeConfig !== null && challengeConfig !== void 0 && challengeConfig.minimized ? 'auto' : '100%',
        transition: function transition(theme) {
          return theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.enteringScreen
          });
        }
      },
      ref: drawerPaperRef
    },
    "data-element": "Drawer",
    "data-component": "ChallengePlayerDrawer",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(EmbedShadowRoot, {
      "data-element": "EmbedShadowRoot",
      "data-component": "ChallengePlayerDrawer",
      "data-source-file": "index.tsx",
      children: open && children
    })
  });
};

export default ChallengePlayerDrawer;